<template>
  <div class="inner" style="padding: 20px 0;">
      <el-container style="padding-bottom: 70px">

        <!--        右半部分-->
          <el-header style="margin-bottom: .2rem;width: 100%;height: .45rem">
<!--            <input v-model="name" placeholder="输入图片名称" size="mini" clearable>-->
            <el-autocomplete v-model="name" style="width: 100%;" :fetch-suggestions="querySearch" placeholder="输入图片名称" @select="handleSelect" prefix-icon="el-icon-search" >
            </el-autocomplete>
            <el-button type="primary" icon="el-icon-search" @click="getData()">搜索</el-button>
          </el-header>
          <el-main style="padding: 0 0.2rem;height: auto;">
            <el-row :gutter="24">
              <el-col :span="6" v-for="item of rows" :key="item.VProductId">
                <div class="grid-content bg-purple" style="height: 185px;margin-bottom: 10px;">
                  <div>
                    <div class="file-img" @click="toImg(item.VAttachmentId)">
                      <img :src="item.VAttachmentRemotePath" style="max-height: 100%;max-width: 100%"/>
                    </div>
                    <div class="file-info">
                      <p class="info-VProductName">{{ item.VAttachmentName }}</p>
                    </div>
                  </div>
                </div>
              </el-col>
            </el-row>
          </el-main>
          <el-aside style="width: auto;text-align: center">
            <el-pagination
              background
              layout="prev, pager, next"
              :total="total"
              :page-size="pageSize"
              @current-change="getPage"
            >
            </el-pagination>
          </el-aside>
    </el-container>
  </div>


</template>

<script>
import { jump, getUser } from '@/untils/auth'
  export default {
    name: "pictureList",
    components: {},
    data() {
      return {
        publicPath: location.origin + location.pathname,
        rows: [],
        name: "",
        total: 200,
        pageSize: 12,
        current: '0',
        categoryname: "",
        data: [],
        message: [],
        dialogTableVisible: false,

        labelList: [],
      }
    },
    created() {
      // this.current = this.$route.query.current;
      // this.name = this.$route.query.searchtext;
      this.categoryname = this.$route.query.categoryname;
      this.getData();
      this.getPage('1');
      this.getHot();
    },
    methods: {
      jump,
      getHot() {
        if (getUser()) {
          var createdBy = JSON.parse(getUser()).principal.VUserId;
          var data = {key: "ess_picture_hotSearch_"+createdBy}
          this.axios.post(window.IPConfig.IP + "/tBHotSearch/queryKeyHotSearCher.do", data).then((res) => {
            if (res.data.status == 200) {
              this.labelList = res.data.obj
            }
          });
        }
      },


      // 切换页码事件
      getPage(val){
        this.current = val;
        this.getData();
      },
      // 跳转图片详情
      toImg(VProductId){
        let routeData = this.$router.resolve({path:'imageDetails',query:{
            VProductId: VProductId,
            current: this.current,
            searchtext: this.name,
            categoryname: this.categoryname,
          }})

        window.open(routeData.href,'_blank')

      /*  this.$router.push(
          {
            path: 'imageDetails',
            query: {
              VProductId: VProductId,
              current: this.current,
              searchtext: this.name,
              categoryid: this.categoryid,
            }
          }
        )*/
      },

      // 图片列表   点击搜索
      getData() {
          var data = {
            auditStatus: "1",
            VAttachmentType: '1',
            IProductStatut: 0,
            categoryname: this.categoryname == undefined ? '' : this.categoryname,
            size: this.pageSize,
            current: this.current == undefined ? 0 : this.current,
            VAttachmentName: this.name == undefined ? '' : this.name,
          }
          this.axios.post(window.IPConfig.IP + "/tBAttachments/queryauditStatusPage.do", data).then((res) => {
            this.rows = [];
            if (res.data.status == 200) {
              this.rows = res.data.obj ? res.data.obj.records : [];
              this.total = Number(res.data.obj.total);
            }
          });
          this.getHot();
      },

      querySearch(queryString, cb) {
        let programList = [];
        for(let i=0;i<this.labelList.length;i++){
          programList.push({'value':this.labelList[i]})
        }

        let results = queryString ? programList.filter(this.createFilter(queryString)) : programList;
        //基本思路就是实现一个过滤器，过滤存在你输入字段的所有数据。
        clearTimeout(this.timeout);
        this.timeout = setTimeout(() => {
          cb(results);
        }, 1000 * Math.random());
      },


      createFilter(queryString) {
        return (restaurant) => {
          return (restaurant.value.indexOf(queryString) > -1);
        };
      },
      handleSelect(item) {
        this.getData();
      },
    },
  };
</script>
<style lang="stylus" scoped>
  .el-row {
    margin-bottom: 0.1rem;

    &:last-child {
      margin-bottom: 0;
    }
  }

  .file-img {
    text-align: center;
    /*background: #f2f3f4;*/
    padding: 0.1rem;
    height: 1.5rem;
    cursor: pointer;
  }

  .el-header{
    display: flex;
    overflow: hidden;
  }

  ::-webkit-scrollbar {
    display: none;
  }

  input{
    width:100%;
    height: auto;
    padding: .1rem 1.2rem .1rem .1rem;
    border: .01rem solid #0e5278;
    border-right: none;
  }

  .el-button{
    border-radius: 0 4px 4px 0;
  }

  .file-info {
    background: #fdffff;
    padding: 0 0.1rem;
    box-sizing: border-box;
    text-align: center;
    overflow: hidden;
    height: auto;
  }

  // 标题
  .info-VProductName {
    text-align: center;
    line-height: 0.25rem;
    height: 0.25rem;
    overflow: hidden;
    -o-text-overflow: ellipsis;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 1;
    word-break: break-all;
    -webkit-box-orient: vertical;
  }

  // 内容描述
  .info-VProductDesc {
    text-align: left;
    line-height: 0.25rem;
    height: 0.5rem;
    overflow: hidden;
    -o-text-overflow: ellipsis;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    word-break: break-all;
    -webkit-box-orient: vertical;
  }

  .info-price {
    display: flex;
    justify-content: center;
    /* justify-content: space-between; */
  }

  // 搜索
  .search-key {
    display: flex;
    justify-content: flex-end;
  }

  .search-input {
    display: flex;
    border: 1px solid $backgroundCOlor;
    margin-right: 0.1rem;
    width: 3rem;
    height: 100%;
  }

  .input-text {
    width: 100%;
  }

  .search-input >>> .el-button {
    background: $backgroundCOlor;
    border-radius: 0;
    border: none;
  }

  .search-input >>> .el-input__inner {
    height: 0.3rem;
    line-height: 0.3rem;
    border: none;
    border-radius: 0;
  }
  .el-autocomplete >>> .el-input__inner{
    height 45px !important;
  }
  .inner {
    position: relative;
  }

  .tree {
    width: 300px;
    overflow: auto;
    position: absolute;
    top: 20px;
    left: -310px;
  }
</style>



// WEBPACK FOOTER //
// src/components/Education/components/index/pictureList.vue